import { BoMItemType, RoutingHeaderRow } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { BoMItemSatisfyActiveFilters } from 'utils/BoMItemSatisfyActiveFilters'
import { BomItemPointer } from './previousAndNextBomItemIdsSelector'

export const getPreviousAndNextItemOfRoute = (
  state: RootAppState,
  bomItemId: string
) => {
  let previous: BomItemPointer = null
  let next: BomItemPointer = null

  const routeIndex = state.project.routingHeadersIds.indexOf(bomItemId)

  if (routeIndex > -1) {
    if (routeIndex === 0) {
      previous = {
        bomItemId: state.project.activeProject?.id,
        bomItemType: BoMItemType.project,
      }
    } else {
      let previousRouteId = null

      for (let i = routeIndex - 1; i >= 0; i--) {
        if (
          BoMItemSatisfyActiveFilters(
            state.project.filters,
            state.project.flatView[state.project.routingHeadersIds[i]]
          )
        ) {
          previousRouteId = state.project.routingHeadersIds[i]
          break
        }
      }

      if (!previousRouteId) {
        // previous will be the project
        previous = {
          bomItemId: state.project.activeProject?.id,
          bomItemType: BoMItemType.project,
        }
      } else {
        // previous will be the last partType (that satisfy the filters); of the previous assembly that satisfy the filters
        const partTypeIdsOfPreviousRoute = (
          state.project.flatView[previousRouteId] as RoutingHeaderRow
        ).filteredPartTypeIds

        if (
          !Boolean(
            partTypeIdsOfPreviousRoute[partTypeIdsOfPreviousRoute.length - 1]
          )
        ) {
          previous = {
            bomItemId: state.project.activeProject?.id,
            bomItemType: BoMItemType.project,
          }
        } else {
          previous = {
            bomItemId:
              partTypeIdsOfPreviousRoute[partTypeIdsOfPreviousRoute.length - 1],
            bomItemType: BoMItemType.row,
          }
        }
      }
    }

    const routeHeader = state.project.flatView[bomItemId] as RoutingHeaderRow

    if (routeHeader) {
      if (Boolean(routeHeader.filteredPartTypeIds[0])) {
        next = {
          bomItemId: routeHeader.filteredPartTypeIds[0],
          bomItemType: BoMItemType.row,
        }
      }
    }

    return {
      previousBomItem: previous,
      nextBomItem: next,
    }
  }

  const bomItem = state.project.flatView && state.project.flatView[bomItemId]

  if (bomItem?.type === 'Row') {
    let rowRouteHeader = undefined

    for (const routingHeaderId of state.project.routingHeadersIds) {
      const routeHeader = state.project.flatView[
        routingHeaderId
      ] as RoutingHeaderRow
      if (routeHeader.filteredPartTypeIds.includes(bomItemId)) {
        rowRouteHeader = routeHeader
        break
      }
    }

    if (rowRouteHeader) {
      const rowIndex = rowRouteHeader.filteredPartTypeIds.indexOf(bomItemId)

      if (rowIndex > -1) {
        if (rowIndex === 0) {
          // we don't have support for routing header details yet.
          // call the function to get the previous
          previous = getPreviousAndNextItemOfRoute(
            state,
            rowRouteHeader.id
          ).previousBomItem
        } else {
          if (!Boolean(rowRouteHeader.filteredPartTypeIds[rowIndex - 1])) {
            previous = {
              bomItemId: state.project.activeProject?.id,
              bomItemType: BoMItemType.project,
            }
          } else {
            previous = {
              bomItemId: rowRouteHeader.filteredPartTypeIds[rowIndex - 1],
              bomItemType: BoMItemType.row,
            }
          }
        }

        if (rowIndex === rowRouteHeader.filteredPartTypeIds.length - 1) {
          // last row of an assembly, next will be the next assembly header
          const parentRouteHeader = state.project.routingHeadersIds.indexOf(
            rowRouteHeader.id
          )

          let nextRouteHeader = null

          for (
            let i = parentRouteHeader + 1;
            i < state.project.routingHeadersIds.length;
            i++
          ) {
            if (
              BoMItemSatisfyActiveFilters(
                state.project.filters,
                state.project.flatView[state.project.routingHeadersIds[i]]
              )
            ) {
              nextRouteHeader = state.project.routingHeadersIds[i]
              break
            }
          }

          if (nextRouteHeader) {
            // we don't have support for details for routing headers yet.
            // call the function to get the next
            next = getPreviousAndNextItemOfRoute(
              state,
              nextRouteHeader
            ).nextBomItem

            // next = {
            //   bomItemId: nextRouteHeader,
            //   bomItemType: BoMItemType.assemblyHeader,
            // }
          }
        } else {
          if (Boolean(rowRouteHeader.filteredPartTypeIds[rowIndex + 1])) {
            next = {
              bomItemId: rowRouteHeader.filteredPartTypeIds[rowIndex + 1],
              bomItemType: BoMItemType.row,
            }
          }
        }
      }
    }
  }

  return {
    previousBomItem: previous,
    nextBomItem: next,
  }
}
